import React, { PropsWithChildren } from 'react';

import { Flex } from '@opendoor/bricks/core';
import { BREAKPOINTS_DICT } from '@opendoor/bricks/theme/legacy/foundations/mediaBreakpoints';

export interface SellDirectLayoutProps {
  isLoading: boolean;
}

// storybook-check-ignore
export const SampleLayout: React.FC<PropsWithChildren> = ({ children }) => {
  return <LayoutContent>{children}</LayoutContent>;
};

const LayoutContent: React.FC<PropsWithChildren> = ({ children }) => (
  <Flex
    data-testid="layout-content"
    flexDirection="column"
    mx="auto"
    gridGap="3"
    width="100%"
    maxWidth={BREAKPOINTS_DICT.MD}
    px={0}
    pt={[0, 0, 9]}
    pb="9"
    w="100%"
  >
    {children}
  </Flex>
);
